export const SUBMIT = 'Payer Onboarding. Submit. Step: Product Interest'
export const FOCUS_EMAIL = 'Payer Onboarding. Focus email input. Step: Product Interest'
